import React from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  GestureResponderEvent,
  // Modal,
} from "react-native";

import Modal from "./base/Modal";

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import StyledButton, { StyledButtonColorTypes } from "../StyledButton";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";

interface IButtonProps {
  type: StyledButtonColorTypes;
  label: string;
  action: VoidFunction;
  fluid: boolean;
}

interface IProps {
  modalState: boolean;
  hideModal: VoidFunction;
  buttons?: IButtonProps[];
  message?: string;
  content?: any;
  icon?: any;
}

const GenericModal: React.FC<IProps> = ({
  modalState,
  hideModal,
  buttons,
  message,
  content,
  icon,
}) => {
  const navigation = useNavigation();
  const clickAreaRef = React.useRef<any>();

  const SingleButton: React.FC<IButtonProps> = ({
    type = "default",
    label = "Ok",
    action = hideModal,
    fluid = false,
  }) => {
    return (
      <StyledButton
        label={label}
        color={type}
        size={fluid ? "lg" : "sm"}
        style={{ marginTop: 10 }}
        action={action}
      />
    );
  };

  const handleClickOutside = (e: GestureResponderEvent) => {
    e.persist();
    if (clickAreaRef.current) {
      if (e.target === clickAreaRef?.current?._nativeTag) {
        hideModal();
      }
    }
  };

  return (
    <Modal
      presentationStyle="overFullScreen"
      animationType="slide"
      transparent={true}
      visible={modalState}
      onRequestClose={() => {
        hideModal();
      }}
    >
      <View
        ref={clickAreaRef}
        onStartShouldSetResponder={(e) => {
          handleClickOutside(e);
          return true;
        }}
        style={styles.overlay}
      >
        <View style={styles.container}>
          <View style={[styles.card]}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => {
                hideModal();
              }}
            >
              {/* <Text style={styles.closeButtonText}>Close</Text> */}
              <Icon name="md-close" size={28} color={Colors.greyColor} />
            </TouchableOpacity>

            {icon ? icon : null}

            {!!message && (
              <Text
                style={[
                  styles.cardBody,
                  {
                    width: 238,
                    color: Colors.whiteColor,
                    letterSpacing: 0,
                    ...FontStyles.size16,
                    ...FontStyles.lh22,
                    ...FontStyles.normal,
                    textAlign: "center",
                    marginBottom: 26,
                  },
                ]}
              >
                {message}
              </Text>
            )}

            {content ? content : null}

            {buttons &&
              buttons.length &&
              buttons.map((item, index) => (
                <SingleButton key={index} {...item} />
              ))}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default GenericModal;

const styles = StyleSheet.create({
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    width: "100%",
    paddingHorizontal: 16,
    justifyContent: "center",
  },
  closeButton: {
    flexDirection: "row",
    alignSelf: "flex-end",
    position: "absolute",
    paddingVertical: 10,
    paddingHorizontal: 16,
  },
  closeButtonText: {
    height: 16,
    width: 36,
    color: Colors.whiteColor,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    ...FontStyles.bold,
    alignSelf: "center",
  },
  card: {
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderRadius: 16,
    marginHorizontal: 16,
    alignItems: "center",
  },
  cardHeader: {
    height: 19,
    width: 157,
    color: "#171C34",
    ...FontStyles.size16,
    ...FontStyles.lh20,
    ...FontStyles.bold,
    marginBottom: 16,
  },
  cardBody: {
    width: 288,
    ...FontStyles.dark,
    ...FontStyles.size14,
    ...FontStyles.lh20,
    ...FontStyles.normal,
  },
});
